import React from 'react';
import ReactDOM from 'react-dom/client';

// Estilos globais e específicos
import './components/css/global.module.css';
import './components/css/sidebar.module.css';
import './components/css/main-content.module.css';

import App from './App'; // Importa o componente principal
import reportWebVitals from './reportWebVitals'; // Importa para medir desempenho

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// Medição de desempenho (opcional)
reportWebVitals();
